import { Check, AlertCircle, Info, X } from 'lucide-react';
import { useToasts, type ToastVariant } from '@/state/toast';

const config: Record<ToastVariant, { border: string; color: string; Icon: typeof Check }> = {
  success: { border: '#10B981', color: '#10B981', Icon: Check },
  error:   { border: '#EF4444', color: '#EF4444', Icon: AlertCircle },
  info:    { border: '#F59E0B', color: '#F59E0B', Icon: Info },
};

/** Контейнер тост-сообщений. Монтируется один раз в App. */
export function ToastContainer() {
  const items = useToasts((s) => s.items);
  const dismiss = useToasts((s) => s.dismiss);

  return (
    <div
      className="fixed flex flex-col"
      style={{ top: 16, right: 16, gap: 8, zIndex: 70, pointerEvents: 'none' }}
      role="region"
      aria-label="Уведомления"
    >
      {items.map((t) => {
        const cfg = config[t.variant];
        const Icon = cfg.Icon;
        return (
          <div
            key={t.id}
            role="status"
            className="bg-white rounded-card flex items-start"
            style={{
              border: '1px solid #E5E7EB',
              borderLeft: `4px solid ${cfg.border}`,
              padding: '12px 16px',
              gap: 12,
              minWidth: 320,
              maxWidth: 420,
              boxShadow: '0 4px 12px rgba(10,22,40,.12)',
              pointerEvents: 'auto',
            }}
          >
            <Icon size={18} stroke={cfg.color} className="shrink-0 mt-0.5" />
            <div style={{ flex: 1, fontSize: 14, fontWeight: 500, color: '#0A1628' }}>{t.message}</div>
            <button
              type="button"
              onClick={() => dismiss(t.id)}
              className="text-muted shrink-0"
              style={{ background: 'none', border: 'none', cursor: 'pointer', padding: 0 }}
              aria-label="Закрыть"
            ><X size={14} /></button>
          </div>
        );
      })}
    </div>
  );
}
